/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {AfterViewInit, Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
    PartNumberChangeDetailSolutionTrialConfigurationModel
// eslint-disable-next-line max-len
} from '../../services/part-number-changes-detail-configuration/models/pnc-solution-trials/part-number-change-detail-solution-trial-configuration.model';
import {StatefulComponent} from '../../../shared/stateful/stateful.component';
import {PartNumberChangesDetailSolutionState} from '../part-number-changes-detail-solution.state';
import {
    PartNumberChangeSolutionMaterialDetailModel
} from '../../models/part-number-change-solution-material-detail.model';
import {InputDisplayModeEnum} from '../../../shared/input/input-display-mode.enum';
import {WarningsEnum} from '../../../shared/warnings/warnings.enum';
import {NgStyle} from '@angular/common';

@Component({
    selector: 'app-part-number-change-detail-solution-trial',
    templateUrl: './part-number-change-detail-solution-trial.component.html',
    styleUrls: [
        '../../styles/pnc-base.component.css',
        '../../styles/pnc-base-solution.component.css',
        './part-number-change-detail-solution-trial.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartNumberChangeDetailSolutionTrialComponent
        extends StatefulComponent<PartNumberChangesDetailSolutionState>
        implements AfterViewInit {
    @Input() solutionTrialNumber: number;
    @Input() isHidden = false;
    @Input() solutionTrials: PartNumberChangeDetailSolutionTrialConfigurationModel;
    private readonly rejectWrapperStyle = {'float': 'left', 'background-color': '#EFEFEF'};

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        this.storeState({
            material: this.solutionTrials?.data?.newPartNumber,
            additionalInformation: this.solutionTrials?.data?.additionalInformation,
            additionalMaterials: this.solutionTrials?.data?.additionalMaterials,
            requiresFlashing: false,
            sendBy: this.solutionTrials?.data?.sentBy
        });
    }

    trackByItem = (index: number, item: PartNumberChangeSolutionMaterialDetailModel): string => item.id;

    initialValuePipe(displayMode: InputDisplayModeEnum, additionalInformation: string): string {
        let pipeValue = additionalInformation;
        if (displayMode === InputDisplayModeEnum.VIEW && additionalInformation == null) {
            pipeValue = '-';
        }
        return pipeValue;
    }

    warningLevel(required: boolean): WarningsEnum {
        return required ? WarningsEnum.WARNING_PNC_SEND : null;
    }

    newPartChange(event: PartNumberChangeSolutionMaterialDetailModel): void {
        this.storeState({
            material: event
        });
    }
}
